import {PostcodesInterface} from "@/components/Postcodes/ValueObject/PostcodesInterface";

export default class DefaultState{
  loading = false;
  postcodeList: PostcodesInterface = {franchises: []};
}
